export default function calculatAnimationTargetPosition(
  parentRef: React.RefObject<HTMLDivElement> | null,
  sourceRef: React.RefObject<HTMLDivElement> | null,
  targetRef: React.RefObject<HTMLDivElement> | null,
) {
  if (sourceRef?.current && parentRef?.current && targetRef?.current) {
    const sourceRect = sourceRef.current.getBoundingClientRect();
    const parentRect = parentRef.current.getBoundingClientRect();
    const targetRect = targetRef.current.getBoundingClientRect();

    // Calculate the center of the source component
    const sourceCenter = {
      x: sourceRect.left + sourceRect.width / 2,
      y: sourceRect.top + sourceRect.height / 2,
    };

    // Calculate the center of the target component
    const targetCenter = {
      x: targetRect.left + targetRect.width / 2,
      y: targetRect.top + targetRect.height / 2,
    };

    // Adjust the calculation to align the centers of the source and target components
    const toPosition = {
      x: targetCenter.x - parentRect.left - (sourceCenter.x - parentRect.left),
      y: targetCenter.y - parentRect.top - (sourceCenter.y - parentRect.top),
    };

    return toPosition;
  }
  return { x: 0, y: 0 };
}
